import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { ChannelsService } from '@core/services/channels.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { Channel } from '@shared/interfaces/channel';
import { State } from '@shared/interfaces/state';

@Component({
  selector: 'app-channels-edit',
  templateUrl: './channels-edit.component.html'
})
export class ChannelsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public channel: Channel;
  public channelsList: Array<Channel> = [];
  public statusList: Array<State> = [];
  public channelForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private channelsService: ChannelsService,
    public dialogRef: MatDialogRef<ChannelsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      let state: State;
      if (this.data.relationships.length) {
        this.data.relationships.forEach((element: any) => {
          state = { id: element.id, name: element.attributes.name };
          this.statusList.push(state);
        });
      }
      this.constants.title = this.appConfig.LANG.channels.title;
      this.constants.action = this.data.action;
      this.channelForm = new FormGroup({
        id: new FormControl('', Validators.required),
        name: new FormControl('', Validators.required),
        idStatus: new FormControl('', Validators.required)
      });

      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.channel = this.data.item;
        this.channelForm.patchValue({
          id: this.channel.id,
          name: this.channel.name,
          idStatus: this.channel.idStatus
        });
      } else {
        if (this.statusList.length <= 0) {
          this.constants.admitted = false;
        } else {
          this.constants.title =
            this.appConfig.LANG.title.add + ' ' + this.constants.title;
        }
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.channelForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.channelsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
